import { TAO_KOE } from './../libs';

const initPopups = ( scopeEl = document ) => {
	// Append popups to body, so they open correctly.
	const popupEls = scopeEl.querySelectorAll( '.mdl_block_acf-popup .mdl_popup' );
	popupEls.forEach( ( popupEl ) => {
		if ( document.body !== popupEl.parentElement ) {
			document.body.appendChild( popupEl );
		}
	} );
};

// Init.
TAO_KOE.ready( 'hotspot.js', () => initPopups() );

// Re-Init on lazyload.
document.addEventListener( 'lazyload.tao', ( ev ) => initPopups( ev.target ) );
